import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './main.css';

////////COMPONENTS////////
import Navigation from './components/global/Navigation';

////////Pages////////
import Home from './pages/Home';
import Construction from './pages/Construction';

export default class App extends Component {
  render() {
    return (
      <Router>
        <Fragment>
          <Navigation  />
          <Switch>
            <Route exact={true} path="/" component={Home} />
            <Route exact path="/blog" component={Construction} />
            <Route path="/projects" component={Construction} />
            <Route component={Construction} />
          </Switch>
        </Fragment>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js